import React, {useEffect, useState} from "react"
import Template from "./Template"
import {useActions} from "../redux/actions";
import * as CallRecordingsActions from "../redux/actions/callRecordings";
import * as practicesActions from '../redux/actions/practice';
import {pageSizeArray} from '../constants';

import {Dropdown, Grid, Input, Button, Pagination, Card, Form, Table, Icon} from "semantic-ui-react";
import {RootState} from "../model";
import {connect} from "react-redux";
import HelpMark from "./help/HelpMark";
import moment from "moment";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'

const CallRecordings: React.FC<any> = (props) => {
    const callRecordingsActions = useActions(CallRecordingsActions);
    const practicesAction = useActions(practicesActions);
    const [state, setStates] = useState({
        practices: [] as any[],
        campaigns: [] as any[],
    });
    const [calendarOpen, toggleCalendarOpen] = useState(false);
    const [filter, setFilter] = useState<any>({pageSize: pageSizeArray[0].value, dates: []});
    const [pagination, setPagination] = useState<any>({activePage: 1, totalPages: 0});
    const [pagedData, setPagedData] = useState<any>({count: 0, rows: [] as any[]});

    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (!calendarOpen) getData();
        }, 1000);
        return () => clearTimeout(timeoutId);

    }, [filter, pagination.activePage]);

    const load = async () => {
        const [practices, campaigns] = await Promise.all([practicesAction.getPractices(), callRecordingsActions.getCampaigns()]);

        const practiceOptions = (practices as any as any[]).map((practice, key) => ({
            text: practice.practice,
            value: practice.practice,
            key
        }));
        setStates({
            practices: practiceOptions,
            campaigns: campaigns.map(({practice}: any) => ({text: practice, value: practice, key: practice}))
        });
    }

    const getData = async () => {
        const data = await callRecordingsActions.getCallDirectory({...filter, ...pagination});
        setPagedData(data);
        setPagination({...pagination, totalPages: Math.ceil(data.count / filter.pageSize)});
    }

    const downloadCallRecording = (key: any, title: string) => {
        callRecordingsActions.downloadRecording(key, title)
            .then((res: any) => {
                const url = res.data;
                window.open(url, "_blank");
            })
    }

    const onFilterChange = (name: string, value: string) => setFilter({...filter, [name]: value})

    const handleDateChange = (_date: any) => {
        const dates = {...filter}.dates ?? [];
        const date = moment(_date).format('YYYY-MM-DD');
        if (!dates[0]) {
            dates[0] = date;
            setFilter({...filter, dates});
            return;
        }

        if (!dates[1]) {
            dates[1] = date;
            toggleCalendarOpen(false);
            setFilter({...filter, dates});
            return;
        }
    };

    const handlePagination = (e: any, {activePage}: any) => setPagination({...pagination, activePage})

    const onCalendarOpen = () => {
        toggleCalendarOpen(true);
        setFilter({...filter, dates: []})
    }

    const inputValue = moment(`${filter.dates[0]}`).format('MM/DD/YYYY') + ' - ' + moment(`${filter.dates[1]}`).format('MM/DD/YYYY');

    const generateTitle = (text: any, dateFolder: any) => {
        const strArr = text.split(' ');

        return [
            <Table.Cell>
                <Icon name="calendar"/>
                {moment(dateFolder, 'M_D_YYYY').format('DD MMM YYYY')},
                {strArr[strArr.length - 2].split('_').join(':')}
                {strArr[strArr.length - 1].split('.')[0]}
            </Table.Cell>,
            <Table.Cell> <Icon name="phone"/> {strArr[0]}</Table.Cell>,
            <Table.Cell> <Icon name="mail"/> {strArr[0]}</Table.Cell>,
        ];
    }

    return (
        <Template activeLink="call-recordings">
            <Grid>
                <Grid.Row>
                    <Grid.Column width={4}>
                        <h2 className="float-left">Call Recordings <HelpMark pageId='1'/></h2>
                    </Grid.Column>
                    <Grid.Column width={12}>
                        <Form>
                            <Form.Group widths="equal" className="mb0">
                                <Form.Field>
                                    <Dropdown
                                        clearable={true}
                                        search={true}
                                        className='mr10 mb15'
                                        placeholder="Campaign"
                                        selection={true}
                                        options={state.campaigns}
                                        onChange={(_, d) => onFilterChange('campaign', d.value as string)}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <DatePicker
                                        className='ui input mr10 mb15'
                                        selected={null}
                                        onChange={handleDateChange}
                                        selectsEnd={!!filter.dates[0]}
                                        startDate={filter.dates[0]}
                                        endDate={filter.dates[1]}
                                        placeholderText="Select Date Range"
                                        shouldCloseOnSelect={!!filter.dates[0]}
                                        onCalendarOpen={onCalendarOpen}
                                        value={!filter.dates[1] ? undefined : inputValue as any}
                                        isClearable={true}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Input
                                        focus
                                        className="mr10 mb15"
                                        placeholder="Search"
                                        icon={{name: 'search', circular: true, link: true}}
                                        onChange={(e, d) => onFilterChange('search', d.value as string)}
                                        value={filter.search}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
            </Grid>

            <Table striped={true} compact={true} color="orange" className="customTable mt0">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content="Date"/>
                        <Table.HeaderCell content="Phone"/>
                        <Table.HeaderCell content="Mail"/>
                        <Table.HeaderCell content="Practice"/>
                        <Table.HeaderCell content="Size"/>
                        <Table.HeaderCell/>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        pagedData.rows?.map((row: any, index: number) => <Table.Row key={index + '_row'}>
                            {generateTitle(row.name, row.dateFolder)}
                            <Table.Cell content={row.practice}/>
                            <Table.Cell content={(+row.size / 1024).toFixed(1) + ' KB'}/>
                            <Table.Cell>
                                <Button
                                    size="mini"
                                    color="orange"
                                    basic={true}
                                    content="Download"
                                    onClick={() => downloadCallRecording(row.url, row.name)}/>
                            </Table.Cell>
                        </Table.Row>)
                    }
                </Table.Body>
            </Table>
            <Grid>
                <Grid.Row>
                    <Grid.Column width={4}>
                        <Form.Field>
                            <Dropdown
                                placeholder="Page Size"
                                selection={true}
                                options={pageSizeArray}
                                onChange={(e, d) => onFilterChange('pageSize', d.value as string)}
                                value={filter.pageSize}
                            />
                        </Form.Field>
                    </Grid.Column>
                    <Grid.Column width={12}>
                        <Pagination
                            activePage={pagination.activePage}
                            totalPages={pagination.totalPages}
                            onPageChange={handlePagination}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Template>
    )
}

function mapStateToProps(state: RootState) {
    return { };
}

export default connect(mapStateToProps)(CallRecordings);
